module.exports = __webpack_public_path__ + "static/media/formplay.5ca1714d.svg";